import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface ToolCallStep {
  id: string;
  type: 'search' | 'analyze' | 'process' | 'tool';
  toolName?: string;
  description: string;
  status: 'pending' | 'running' | 'completed';
  args?: Record<string, unknown>;
  result?: unknown;
}

export interface ToolCallDisplayProps {
  thinkingText?: string;
  steps: ToolCallStep[];
  isVisible: boolean;
  defaultExpanded?: boolean;
  className?: string;
}

/**
 * Minimal tool call display - just shows pulsing text
 * ChatGPT-style simple "Searching..." indicator
 */
export const ToolCallDisplay: React.FC<ToolCallDisplayProps> = ({
  thinkingText,
  isVisible,
  className,
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const displayText =
    thinkingText || t('chat.toolCall.thinking', 'Thinking...');

  return (
    <div className={cn('w-full', className)}>
      <span className="text-sm text-muted-foreground animate-pulse">
        {displayText}
      </span>
    </div>
  );
};

export default ToolCallDisplay;
